<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import { TRANSITION_DELAY } from '$lib/global/constants';

    import { page } from '$app/stores';
    import { isBlockRevealed, setBlockRevealContext } from '$lib/Stores/blockReveal';

    import { derived } from 'svelte/store';

    import { getBlockComponent } from './map';

    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Field } from '$lib/types/Field';
    import type { Language } from '$lib/types/Language';
    import type { ResultMapping } from '$lib/types/ResultMapping';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let content = {};
    export let childComponents: Component[] = [];
    export let resultMapping: ResultMapping;
    export let theme: Theme;
    export let nextPage = '';
    export let currentPage = '';
    export let componentType = '';
    export let campaignId = '';
    export let campaignVersionId = '';
    export let companyId = '';
    export let cookiesEnabled = false;
    export let fields: Field[] = [];
    export let index = 0;
    export let firstResultPage = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'en';
    export let layout = DEFAULT_LAYOUT;
    export let onClick: ((event: MouseEvent | TouchEvent) => any) | undefined = undefined;

    const transitionEffect: TransitionEffect = $page?.data?.theme?.transition || 'none';

    const svelteComponent = getBlockComponent(componentType, content);

    const transitionDelay = index * TRANSITION_DELAY;

    // CAP-4418: Blocks that sit after a sandboxed AI embed whose height is still
    // unknown are rendered but not painted, so they never appear in a position
    // they are about to be pushed out of. See `$lib/Stores/blockReveal`.
    //
    // `display: contents` keeps the wrapper out of layout entirely, so the block
    // stays a direct flex/grid item of the column or row that holds it, while
    // `visibility` still inherits through to it.
    $: isRevealed = $isBlockRevealed(id);

    // Hand the same state to this block's `Transition`s, which hold their
    // entrance animation until there is someone to see it.
    setBlockRevealContext(derived(isBlockRevealed, (blockIsRevealed) => blockIsRevealed(id)));
</script>

{#if svelteComponent}
    <div style:display="contents" style:visibility={isRevealed ? null : 'hidden'}>
        <svelte:component
            this={svelteComponent}
            {id}
            {content}
            {theme}
            {currentPage}
            {nextPage}
            {childComponents}
            {resultMapping}
            {campaignId}
            {campaignVersionId}
            {companyId}
            {cookiesEnabled}
            {fields}
            {firstResultPage}
            {transitionDelay}
            {transitionEffect}
            {trackingProperties}
            {language}
            {layout}
            {onClick}
        />
    </div>
{/if}
